import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { HTMLAttributes } from 'react'

// component
import Icon from '@/assets/icons'
import Image from '@/components/common/Image'
import FollowButton from './components/follow-button'

// Libs
import signalData from '@/assets/lotties/signal.json'
import Insight from '@/components/shared/Insight'
import { useMemberData } from '@/hooks/useMemberData'
import { UserType } from '@/types/user-story-carousel'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Styles
import styles from './style.module.scss'
import { USER_ROLE } from '@/types/user-profile'

const cx = classnames.bind(styles)

type UserStoryCarouselProps = HTMLAttributes<HTMLDivElement> & {
  users: UserType[]
  isFollowSuggest?: boolean
}

const UserStoryCarousel = ({ users, isFollowSuggest, ...props }: UserStoryCarouselProps) => {
  const router = useRouter()
  const { memberData } = useMemberData()

  const hasUsers = users && users.length > 0

  const navigateToProfile = (memberId: string) => {
    handleRoutePushWithQuery({ router, pathname: `/profile/${memberId}` })
  }

  return (
    <>
      {hasUsers && (
        <div className={cx('user-story-carousel', { isFollowSuggest })} {...props}>
          {users.map((user, index) => {
            const isMe = user.memberId === memberData?.memberInfoId
            return (
              <div key={index} className={cx('user-story-carousel-item__wrapper')} onClick={() => navigateToProfile(user.memberId)}>
                <div className={cx('user-story-carousel-item', { isLive: user.isLive })}>
                  <div className={cx('user-story-carousel-item-image', { isLive: user.isLive })}>
                    {user.coverImageUrl ? (
                      <Image src={user.coverImageUrl} alt='vendor-photo' fill style={{ objectFit: 'cover' }} />
                    ) : (
                      <Icon.DefaultHeadShot />
                    )}
                  </div>
                  {user.isLive && !isFollowSuggest && (
                    <div className={cx('user-story-carousel-item-live')}>
                      {
                        <Insight
                          handleInsightClick={() => {}}
                          theme='gray'
                          status='empty'
                          isCircle
                          customLottieData={signalData}
                          className={cx('user-story-carousel-item-live-insight')}
                        />
                      }
                      {<span className={cx('user-story-carousel-item-live-text')}>LIVE</span>}
                    </div>
                  )}
                  {isFollowSuggest && !isMe && (
                    <FollowButton
                      className={cx('follow-button')}
                      memberId={user.role === USER_ROLE.MERCHANT ? String(user.merchantId) : user.memberId}
                      isFollowed={user.isFollowed}
                      followeeType={user.role}
                    />
                  )}
                </div>
                {isFollowSuggest && <span className={cx('user-story-carousel-item__nick-name')}>{user.nickName}</span>}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
export default UserStoryCarousel
